import React from 'react';
import { graphql } from 'gatsby';
import {
  StyledSubHeroBannerBlock,
  StyledSubHeroBannerBlockWrapper
} from './styles';
import TrustLogoBar from '../../TrustLogoBar';
import Img from 'gatsby-image';
import { uid } from 'react-uid';

const GlobalContentBlocksSubHeroBannerBlock = ({ block }) => {
  // data logic goes here, if needed

  return (
    <StyledSubHeroBannerBlockWrapper>
      <StyledSubHeroBannerBlock>
        <div className="sub-hero-banner--inner">
          <div className="sub-hero-banner--child-first">
            {/*<Img fluid={block.image.imageFile.childImageSharp.fluid} alt={block.image.alt}/>*/}
            <img src={block.image.sourceUrl}/>
          </div>
          <div className="sub-hero-banner--child-mid">
            <div>
              <h2>{block.headline}</h2>
              <p>{block.mainText}</p>
            </div>
          </div>
          <div className="sub-hero-banner--child-last">
            <a href={block.buttonLink}>{block.buttonText}</a>
          </div>
        </div>
      </StyledSubHeroBannerBlock>      
      <TrustLogoBar isHome className="trust-logo-bar" />
    </StyledSubHeroBannerBlockWrapper>
  );
};

export default GlobalContentBlocksSubHeroBannerBlock;

export const query = graphql`
  fragment SubHeroBannerBlockFragment on WPGraphQL_Page {
    acfGlobalContentBlocks {
      contentBlocks {
        ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_SubHeroBannerBlock {
          fieldGroupName
          headline
          mainText
          buttonText
          buttonLink
          image {
            altText
            sourceUrl
            imageFile {
              childImageSharp {
                fluid(maxWidth: 460) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`;
